/**
 * @author      Muskan Khan
 * @date        July, 2025
 * @copyright   www.ibirdsservices.com
 */

import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Container, Card } from "react-bootstrap";
import { useNavigate } from 'react-router-dom'
// import WhatsAppAPI from '../../api/WhatsAppAPI';
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from 'react-bs-datatable';
import { Link } from "react-router-dom";
// import Confirm from "../Confirm";
import Confirm from "../../Confirm";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SparkApi from "../../../api/SparkApi";
import { FaPlus } from "react-icons/fa"
import { ShimmerTable } from "react-shimmer-effects";
import "../WatConnect.css";

const CompanyList = () => {
  const [isSpinner, setIsSpinner] = useState(false);
  const navigate = useNavigate();
  const [body, setBody] = useState();
  const [statusRow, setStatusRow] = useState(undefined);

  useEffect(() => {
    init();
  }, []);

  async function init() {
    const result = await SparkApi.fetchCompany();
    setIsSpinner(true);
    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
  }

  const handleEditButton = (row) => {
    navigate(`/company/edit/${row.id}`, { state: row });
  };

  const statusHandler = (val) => {
    setStatusRow(val);
  };

  const companyListHandler = async () => {

    let editRecord;

    setStatusRow((prevData) => {
      editRecord = { ...prevData, company_active: !prevData.company_active };
      return editRecord;
    });

    let response = {};
    //    console.log(editRecord)
    response = await SparkApi.updateCompany(editRecord);
    //    console.log(response)
    if (response.success) {
      toast.success(response.message);
      setStatusRow(undefined);
      init();
    } else {
      toast.error(response.message);
    }
  };

  const labels = { beforeSelect: " " };
  const header = [
    {
      title: 'Company Name', prop: 'name', isFilterable: true,
      cell: (row) => (
        <Link
          to={"/company/" + row.id}
          state={row}
        >
          {row.name}
        </Link>
      )
    },

    { title: "Tenant Code", prop: "tenantcode", isFilterable: true },
    { title: "Email", prop: "adminemail", isFilterable: true },
    {
      title: "Status",
      prop: "company_active",
      isFilterable: true,
      cell: (row) => {
        return (
          <Button className={"btn-sm"} variant={row?.company_active ? "success" : "danger"} onClick={() => statusHandler(row)}>{row.company_active ? 'Active' : 'Inactive'}</Button>
        )
      }
    },
    {
      title: "Action",
      prop: "company_active",
      isFilterable: true,
      cell: (row) => {
        return (
          <Button
            className="btn-sm mx-2"
            variant="primary"
            onClick={() => handleEditButton(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </Button>
        );
      },
    },
  ];

  const createCompany = () => {
    console.log("addd");
    navigate(`/company/add`);
  }


  return (
    <>
      <Container className='mt-5'>
        <Row className="mx-5 mb-4">
          <Card className="p-4 bg-white shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small className="text-muted">
              The company module manages organization-specific data like name, industry, contact info, and settings.
              It acts as the central entity to which users, modules, and plans are linked.
              This helps in organizing multi-tenant architecture and enables personalized configurations per company.
            </small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <div className="bg-white shadow-sm border-0 rounded-3 p-4">
              <h5 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                {/* <motion.span
                  animate={{ scale: [1, 1.4, 1.1, 1.4, 1] }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
                  className="text-5xl"
                >
                  ✨
                </motion.span> */}
                Company Records
              </h5>

              <DatatableWrapper body={body ? body : []} headers={header} paginationOptionsProps={{ initialState: { rowsPerPage: 10, options: [5, 10, 15, 20] } }}>
                <Row className="mb-3">
                  <Col lg={3} sm={10} xs={10} className="d-flex flex-col justify-content-end align-items-end">
                    <Filter className="p-2" />
                  </Col>
                  <Col lg={4} sm={2} xs={2} className="d-flex justify-content-start">
                    <PaginationOptions labels={{ beforeSelect: " " }} />
                  </Col>
                  <Col lg={5} sm={12} xs={12} className="mt-2 d-flex justify-content-end align-items-center gap-2">
                    {/* <Button variant="outline-secondary" size="sm" onClick={() => createCompany()}>
                      Add New Company
                    </Button> */}
                    <Button
                      className="btn-sm text-dark"
                      variant="outline-primary mx-2"
                      onClick={() => createCompany()}
                    >
                      <FaPlus size={10} className="me-1" /> Add New Company
                    </Button>
                  </Col>
                </Row>

                <div className="table-responsive">
                  <Table bordered hover className="custom-table align-middle">
                    <TableHeader />
                    <TableBody />
                  </Table>
                </div>
                <Pagination />
              </DatatableWrapper>
            </div>
          </Col>
        </Row>
      </Container>

      {/* {isSpinner ? */}
      {/*
      <Container className='mb-5'>
        <Row className='mx-5 g-0'>
          <Col lg={12} sm={12} xs={12} className="mb-3">
            <Row className="g-0">
              <Col lg={12} sm={12} xs={12} >
                <DatatableWrapper
                  body={body ? body : []}
                  headers={header}
                  paginationOptionsProps={{ initialState: { rowsPerPage: 10, options: [5, 10, 15, 20], } }}
                >
                  <Row className="mb-2">
                    <Col lg={3} sm={10} xs={10} className="d-flex flex-col justify-content-end align-items-end" >
                      <Filter />
                    </Col>
                    <Col lg={4} sm={2} xs={2} className="d-flex flex-col justify-content-start align-items-start" >
                      <PaginationOptions labels={labels} />
                    </Col>

                    <Col lg={5} sm={12} xs={12} className="mt-2 d-flex flex-col justify-content-end align-items-end"  >
                      <Button className="btn btn-sm" variant="outline-secondary" onClick={() => createCompany()}>
                        Add New Company
                      </Button>
                    </Col>
                  </Row>
                  <Table striped className="data-table" responsive="sm">
                    <TableHeader />
                    <TableBody />
                  </Table>
                  <Pagination />
                </DatatableWrapper>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container> */}
      {/* :
                <div className="sk-cube-grid">
                    <div className="sk-cube sk-cube1"></div>
                    <div className="sk-cube sk-cube2"></div>
                    <div className="sk-cube sk-cube3"></div>
                    <div className="sk-cube sk-cube4"></div>
                    <div className="sk-cube sk-cube5"></div>
                    <div className="sk-cube sk-cube6"></div>
                    <div className="sk-cube sk-cube7"></div>
                    <div className="sk-cube sk-cube8"></div>
                    <div className="sk-cube sk-cube9"></div>
                </div>
            } */}
      <ToastContainer />

      {statusRow && (
        <Confirm
          show={statusRow}
          onHide={() => setStatusRow(undefined)}
          changeCompanyStatus={companyListHandler}
          title={`Confirm ${statusRow?.company_active ? "Inactive ?" : "Active ?"}`}
          message="You are going to update the status. Are you sure?"
          table="company"
        />
      )}
    </>
  )
}

export default CompanyList
